/*
  Phatstix — SHARED KLAVIYO CLIENT.

  Why this file exists: the waitlist modal (assets/ph-waitlist.js) and the Clippy 10% capture
  (assets/ph-clippy.js) were each carrying their own copy of the same POST — same endpoint, same
  revision header, same JSON:API body shape, differing only in custom_source and the profile
  properties. Two copies means the revision date has to be bumped twice and can silently drift.
  There is now one.

  POST https://a.klaviyo.com/client/subscriptions?company_id=<public key> is Klaviyo's PUBLIC
  browser endpoint: no API key, no Authorization header, 202 on success. The company id is a public
  identifier that Klaviyo's own onsite script prints in page source on every request, so it is not
  a secret and carries no write access beyond list subscription.
  Verified against the Klaviyo reference on 22 Aug 2026 at revision 2026-07-15.

  window.phKlaviyo
    .subscribe({ company, listId, email, source, properties })  -> Promise<Response>
    .captured()      has this browser already given us an address, by any route
    .markCaptured()  record that it has
  The captured flag is deliberately GENERIC and not per-widget: someone who joined the waitlist
  should not then be chased by Clippy for the same address. Whichever form runs first sets it.
*/
(function () {
  'use strict';

  var REVISION = '2026-07-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var CAPTURED_KEY = 'ph_email_captured';

  // localStorage throws outright in some privacy modes, so every access is guarded and a failure
  // reads as "not captured" (fails open, shows the form) rather than breaking the page.
  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function subscribe(opts) {
    opts = opts || {};
    var props = opts.properties || {};
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: opts.source || 'Phatstix site',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: opts.email,
                properties: props,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: opts.listId } } }
      }
    };
    return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(opts.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    });
  }

  window.phKlaviyo = {
    REVISION: REVISION,
    ENDPOINT: ENDPOINT,
    CAPTURED_KEY: CAPTURED_KEY,
    subscribe: subscribe,
    captured: function () { return get(CAPTURED_KEY) === '1'; },
    markCaptured: function () { set(CAPTURED_KEY, '1'); }
  };
})();
